export default `require 'jwt'

PrivateKey = 'YOUR_PRIVATE_SSO_KEY'

def createCannyToken(user)
  userData = {
    avatarURL: user.avatar_url, # optional, but preferred
    email: user.email,
    id: user.id,
    name: user.name
  }

  JWT.encode(userData, PrivateKey, 'HS256')
end`;
